import { createSlice } from '@reduxjs/toolkit';
import { TMeta } from '../../../types';
import { TCase, TCaseCount, TCaseFlag } from '../../../types/cases';

interface CaseState {
  cases: TCase[];
  caseDetail: TCase;
  flags: TCaseFlag;
  meta: TMeta;
  count: TCaseCount;
}

const initialState: CaseState = {
  cases: [],
  caseDetail: <TCase>{},
  flags: <TCaseFlag>{},
  meta: <TMeta>{},
  count: <TCaseCount>{}
};

const caseSlice = createSlice({
  name: 'case',
  initialState,
  reducers: {
    getAllCase(state, action) {
      state.cases = action.payload.results || [];
      state.meta = action.payload.meta || {};
    },
    getOneCase(state, action) {
      state.caseDetail = action.payload.row || null;
    },
    getCaseCount(state, action) {
      state.count = action.payload.row || {};
    },
    getAllCaseFlags(state, action) {
      state.flags = action.payload.results || {};
    }
  }
});

export const { getAllCase, getOneCase, getCaseCount, getAllCaseFlags } =
  caseSlice.actions;
export default caseSlice.reducer;
